import { useState } from 'react';
import { Heading } from '@acb_devel/design-system';
import { useModal } from '@acb_devel/design-system';
import { useEventsContext } from '@contexts/EventsContext';
import { ActiveEventCard } from '@components/assessors/molecules/ActiveEventCard/ActiveEventCard';
import { DeleteEventModal } from '@components/assessors/organisms/DeleteEventModal/DeleteEventModal';
import { EditEventModal } from '@components/assessors/organisms/EditEventModal/EditEventModal';
import type { Event } from '@services/events';

import styles from './ActiveEventsList.module.scss';

export function ActiveEventsList() {
  const { events } = useEventsContext();
  const {
    isOpen: isDeleteOpen,
    openModal: openDeleteModal,
    closeModal: closeDeleteModal,
  } = useModal();
  const {
    isOpen: isEditOpen,
    openModal: openEditModal,
    closeModal: closeEditModal,
  } = useModal();

  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);

  function setEventToEdit(event: Event) {
    setSelectedEvent(event);
    openEditModal();
  }

  function setEventToDelete(event: Event) {
    setSelectedEvent(event);
    openDeleteModal();
  }

  return (
    <>
      <div className={styles.activeEventsList}>
        <div className={styles.activeEventsList__header}>
          <Heading as="h2" variant="heading-1">
            {`Próximos eventos (${events.length.toString()})`}
          </Heading>
        </div>
        <div className={styles.activeEventsList__content}>
          {events.map((event) => (
            <ActiveEventCard
              key={event.id}
              event={event}
              onEdit={setEventToEdit}
              onDelete={setEventToDelete}
            />
          ))}
        </div>
      </div>
      {selectedEvent && (
        <DeleteEventModal
          isOpen={isDeleteOpen}
          onClose={closeDeleteModal}
          event={selectedEvent}
        />
      )}
      {selectedEvent && (
        <EditEventModal
          isOpen={isEditOpen}
          onClose={closeEditModal}
          event={selectedEvent}
        />
      )}
    </>
  );
}
